import { styled } from "../../../../../styles";

export const BuilderLayoutContainer = styled("div", {
  width: "100vw",
  height: "100vh",
  position: "relative",
  backgroundColor: "$gray-20",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  variants: {
    hasDashboardLayout: {
      true: {
        marginTop: "-62px",
        zIndex: 2001,
      },
    },
  },
});

export const Header = styled("div", {
  width: "100%",
  height: "62px",

  position: "absolute",

  backgroundColor: "var(--colors-builder-banner-background)",
  padding: "0 40px 0 68px",
  boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.16)",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  zIndex: 1,

  p: {
    color: "$white",
    fontSize: "16px",
    fontWeight: "00",
    lineHeight: "22px",
  },
});

export const TitleContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  width: "100%",
  justifyContent: "center",

  span: {
    fontSize: "18px",
    margin: "0 8px",

    fontFamily: "$openSans",
    color: "$white",
  },

  p: {
    fontWeight: "600 !important",
  },
});

export const Title = styled("p", {
  fontFamily: "$nunito",

  fontWeight: 700,
  fontSize: "$text-xxl",

  color: "$gray-100",

  "@sm": {
    fontSize: "$text-lg",
    lineHeight: "19px",
  },
});

export const CancelButton = styled("div", {
  width: "110px !important",
  height: "38px",

  padding: "0px 40px",
  borderRadius: "20px",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "22px",
  color: "$white",

  cursor: "pointer",

  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
  },
});

export const AnswerSurveyContainer = styled("div", {
  height: "calc(100vh - 62px)",
  width: "100vw",

  display: "flex",
  justifyContent: "center",

  marginTop: 62,

  backgroundColor: "$white",
});
